'use client';

import { Subsidiary } from '@coolblue-development/constants';
import { freddyTheme, IconButton, Popover, Typography } from '@coolblue-development/freddy';
import { InfoCircled } from '@coolblue-development/icons';
import { useFreddyTranslations } from '@coolblue-development/next-design-system-utils/client';
import { useRef, useState } from 'react';

import { tooltipTextMap } from '../tooltipText';

type Props = {
  subsidiary: Subsidiary;
};

export const PopoverForDisabledLanguage = ({ subsidiary }: Props) => {
  const [isPopoverOpen, setIsPopoverOpen] = useState(false);
  const iconRef = useRef<HTMLButtonElement | null>(null);
  const popoverTranslations = useFreddyTranslations('popover');

  return (
    <>
      <IconButton
        ref={iconRef}
        onClick={() => setIsPopoverOpen(!isPopoverOpen)}
        aria-label='Show language information'
        sx={{
          width: '2rem',
          height: '2rem',
          marginLeft: freddyTheme.spacing[200],
          padding: 0,
          minWidth: 'auto'
        }}
      >
        <InfoCircled fill={freddyTheme.color.icon.base} />
      </IconButton>
      <Popover
        translations={popoverTranslations}
        referenceElement={iconRef.current}
        open={isPopoverOpen}
        onClose={() => setIsPopoverOpen(false)}
        sx={{ width: '23rem' }}
      >
        <Typography variant='caption' color={freddyTheme.color.font.base}>
          {tooltipTextMap[subsidiary]}
        </Typography>
      </Popover>
    </>
  );
};
